import { useMemo } from 'react';

import { useAuthContext } from './context';

export const FINANCIAL_OVERRIDE_PERMISSION_KEY = 'agreement/financial-override' as const;

/**
 * Financial Override permission:
 * - Implemented as a "tab" permission using the virtual Agreements route `agreement/financial-override`.
 * - Used to gate both Agreement lockdown overrides and Settings > Revenue Lockdowns visibility.
 */
export function useFinancialOverridePermission(): boolean {
  const { permissions } = useAuthContext();

  return useMemo(() => {
    const tabPermissions = permissions?.tab ?? [];
    const permission = tabPermissions.find((p) => String(p.resource) === FINANCIAL_OVERRIDE_PERMISSION_KEY);
    return Boolean(permission?.view);
  }, [permissions?.tab]);
}
